import { useNavigate } from 'react-router-dom';

export default function BCUpdatedModal({ show, onClose }) {
  const navigate = useNavigate();
  if (!show) return null;

  return (
    <div className="modal-backdrop-fo" onClick={onClose}>
      <div className="modal-fo" onClick={e => e.stopPropagation()}>
        <button className="mcl" onClick={onClose}>✕</button>

        <div className="d-flex align-items-center gap-3 mb-3">
          <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: 44, height: 44, background: 'var(--green2)', fontSize: 22 }}>📊</div>
          <div>
            <div className="m-title mb-0">BC Auto-Updated — Farminform Q1 2026</div>
            <div style={{ fontSize: 12, color: 'var(--t3)' }}>2 hours ago · Valsartan 160 mg</div>
          </div>
        </div>

        <div className="p-3 rounded-3 mb-3" style={{ background: 'var(--green2)' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--green)', marginBottom: 8 }}>✦ Nova recalculation</div>
          <div className="row g-2">
            {[
              { label: 'Previous Y1', value: '€2.4M', color: 'var(--navy)' },
              { label: 'Change', value: '+€180K', color: 'var(--green)' },
              { label: 'Updated Y1', value: '€2.6M', color: 'var(--green)' },
            ].map((k, i) => (
              <div className="col-4 text-center" key={i}>
                <div style={{ fontSize: 10, color: 'var(--t3)' }}>{k.label}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: k.color, fontFamily: "'Syne',sans-serif" }}>{k.value}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: '11.5px', color: 'var(--t2)', marginTop: 10, lineHeight: 1.6 }}>
            Reason: NL ARB market grew +8.2% YoY (Farminform Q1 2026). 2 competitors delisted Q1. Market share model revised upward from Y2.
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 pt-3 border-top">
          <button className="btn btn-s" onClick={onClose}>Dismiss</button>
          <button className="btn btn-p" onClick={() => { onClose(); navigate('/bc/editor'); }}>Review Full BC →</button>
        </div>
      </div>
    </div>
  );
}
